import {
	Stack,
	RadioGroup,
	FormControl,
	InputLabel,
	MenuItem,
	InputAdornment,
	CircularProgress,
	Backdrop,
} from "@mui/material";
import { useEffect, useState, Fragment } from "react";
import { StyledAutocomplete, StyledTextField, StyledSelect, FormControlSingle } from "../styles";
import { Search } from "@mui/icons-material";
import Scrollbars from "react-custom-scrollbars-2";
import { Mandatory } from "../../../../components/tabs/FMForm/FormHelpers";
import { profileApiServices } from "../../../../services/userApiServices/profile";
import { showToast } from "../../../../components/ui/toaster";
import { CustomButton, CustomButtonWithoutBorder, FormLabelTypography, RadioInputBoxes, StyledFormControl, StyledRadio } from "./styles";
import webSocketApiService from "../../../../services/socket/wsApiServices";



const EditRoleDetails = (props) => {
	const { user, isDisabled, isModalSaving } = props;
	const [backdropLoader, setBackdropLoader] = useState(false);
	const [data, setData] = useState({
		statusOfSeaFearer: "shore",
		dataLoaded: true,
		imoDataLoaded: true,
		sailingStatus: user.sailingStatus,
		shipName: user.shipName || '',
		isShipNameOpen: false
	});
	const fieldBorderColor = '#E7E7FF';
	const fieldHoverBorderColor = '#8387BD';
	const styles = {
		textField: {
			'& fieldset': {
				borderColor: `${fieldBorderColor} !important`,
			},
			'&:hover': {
				borderColor: `${fieldHoverBorderColor} !important`,
			},
			'&:hover fieldset': {
				borderColor: `${fieldHoverBorderColor} !important`,
			},
			'&.Mui-focused fieldset': {
				borderColor: `${fieldHoverBorderColor} !important`,
			},
		}
	}

	const handleRoleChange = (value) => {
		const rankList = data.rolesObject[data.statusOfSeaFearer].filter(
			(x) => x.info === value
		)[0].level2;
		setData((prevData) => ({
			...prevData,
			role: value,
			rankList,
			rank: "",
		}));
	};

	const handleRankChange = (e) => {
		setData((prevData) => ({ ...prevData, rank: e.target.value }));
	};

	const handleSeafarerChange = (statusOfSeaFearer) => {
		setData((prevData) => ({
			...prevData,
			statusOfSeaFearer,
			role: "",
			rank: "",
			rankList: data.rankList,
		}));
	};

	const setOpen = (value) => {
		setData((prevData) => ({ ...prevData, isShipNameOpen: value }));
	};

	const getShipDetails = async (searchKey, field) => {
		if (field === "shipName" && searchKey.length < 8) {
			setData((prevData) => ({ ...prevData, dataLoaded: true, shipNameError: true, shipName: searchKey }));
			const message = "Please enter at least eight characters to search for a vessel by name or search it using the IMO number"
			return showToast('error', message);
		}
		if (field === "shipName") {
			setData((prev) => ({ ...prev, dataLoaded: false }))
		} else {
			setData((prev) => ({ ...prev, imoDataLoaded: false }))
		};
		let payload = { [field]: searchKey };
		const res = await webSocketApiService.getShipDetails(payload);
		if (res) {
			if (field === "shipName") {
				setData((prevData) => ({
					...prevData,
					shipName: searchKey,
					dataLoaded: true,
					shipList: res.ships.map((x) => ({ ...x, label: x.shipName, shipIMO: (x.IMO || '') })),
					isShipNameOpen: true,
				}));
			} else if (field === "shipIMO") {
				const shipList = res.ships.map((x) => ({ ...x, label: x.shipName, shipIMO: (x.IMO || '') }));
				const singleShip = shipList.length === 1 ? shipList[0] : null;
				setData((prevData) => ({
					...prevData,
					shipIMO: searchKey,
					imoError: res.ships.length == 0,
					imoDataLoaded: true,
					shipList,
					...(singleShip && {
						shipName: singleShip.label,
						shipIMO: singleShip.shipIMO,
						isShipNameOpen: false, // Close the dropdown if a single ship is found
					}),
				}));
			}
		}
	};

	const handleShipNameSearch = (e) => {
		if (e.target.name === "shipIMO" && !/^\d*$/.test(e.target.value)) {
			return;
		}
		if (e.target.value != "") {
			if (e.target.name == "shipName") {
				setData((prevData) => ({
					...prevData,
					shipName: e.target.value,
					searchKey: e.target.value,
					shipNameError: false,
				}));
			} else {
				setData((prevData) => ({
					...prevData,
					shipIMO: e.target.value,
					searchKey: e.target.value,
					imoError: false,
				}));
			}
		} else {
			setData((prevData) => ({
				...prevData,
				[e.target.name]: e.target.value,
				imoError: false,
				shipNameError: false,
				dataLoaded: true,
				imoDataLoaded: true,
			}));
		}
	};

	const saveProfile = async (e) => {
		let {
			role,
			rank,
			shipName,
			shipIMO,
			sailingStatus,
			statusOfSeaFearer,
			userName,
		} = data;

		if (userName?.trim() === "") {
			return showToast('warn', "Username is required. Please enter one.");
		}

		if (role == "" || rank == "") {
			return showToast('warn', "Please select a role.");
		}

		if (sailingStatus === true && (!shipName || !shipIMO)) {
			return showToast('warn', "Please add Vessel details.");
		}

		let newData = {
			rankLevel1: statusOfSeaFearer,
			rankLevel2: role,
			rankLevel3: rank,
			role,
			rank,
			userName,
			sailingStatus,
		};
		if (sailingStatus) {
			newData = { ...data, ...newData, shipName, shipIMO };
		}
		setData((prevData) => ({ ...prevData, disableCancel: true, isDirty: false }));
		try {
			await props.save(e, newData);
			setTimeout(() => {
				props.closeModal();
			}, 1500);
		} catch (err) {
			console.log("Profile Update failed");
		}
	};

	const handleNameChange = (e) => {
		setData((prevData) => ({ ...prevData, userName: e?.target?.value }));
	};

	const setConfig = async () => {
		let res = await webSocketApiService.GetLevel3Ranks();
		if (res) {
			let rolesObject = res;
			let newData = { ...data };
			let {
				rankLevel3,
				rankLevel2,
				rank,
				role,
				userName,
				rankLevel1,
				shipName,
				shipIMO,
				sailingStatus,
			} = user;
			let statusOfSeaFearer = rankLevel1 ? rankLevel1.toLowerCase() : "shore",
				shipList = [];
			rankLevel2 = rankLevel2 || rank;
			rankLevel3 = rankLevel3 || role;

			if ((rankLevel2) && rankLevel3) {
				const rankList =
					rolesObject[statusOfSeaFearer].filter((x) => x.info === rankLevel2)[0]
						?.level2 || [];
				newData = {
					...data,
					userName,
					statusOfSeaFearer,
					role: rankLevel2,
					rankList,
					rank: rankLevel3,
					rolesObject,
				};
				setData((prevData) => ({
					...prevData,
					...newData
				}));
			}

			if (sailingStatus === false) {
				shipName = '';
				shipIMO = '';
			}

			if (!shipIMO || !shipName) {
				sailingStatus = false;
			}

			if (shipName) {
				shipList = [{ label: shipName, shipName, IMO: shipIMO }];
			}

			setData({
				...newData,
				shipName,
				shipIMO,
				sailingStatus,
				userName,
				shipList,
				rolesObject,
				statusOfSeaFearer,
				dataLoaded: true, // Mark data as loaded
				imoDataLoaded: true,
			});
			setBackdropLoader(true);
		}
	};

	const handleShipSelect = ({ shipName, IMO }) => {
		let { imoError, imoDataLoaded, shipNameError } = data;
		let newData = {
			...data,
			searchKey: "",
			shipName,
			shipIMO: IMO,
		};
		if (imoError) newData.imoError = false;
		if (shipNameError) newData.shipNameError = false;
		if (!imoDataLoaded) newData.imoDataLoaded = true;
		setData((prevData) => ({ ...prevData, ...newData }));
	};

	useEffect(() => {
		(async () => {
			await setConfig();
		})();
	}, []);

	return (
		<>
			<Backdrop
				sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
				open={!backdropLoader}
			>
				<CircularProgress />
			</Backdrop>
			<Scrollbars autoHide>
				<Stack
					flexDirection="column"
					justifyContent="center"
					sx={{ margin: "1rem" }}
				>
					<StyledTextField
						label={<>Name <Mandatory mandatory fontSize="medium" top="0" /></>}
						sx={{
							...styles.textField,
							'& .MuiInputBase-root': {
								fontFamily: "Figtree,sans-serif !important",
								fontSize: "16px !important",
								color: "#4f5b7d !important",
								paddingRight: "9px !important",
								backgroundColor: "#fff",
								fontWeight: "500"
							},
							"& .MuiOutlinedInput-root": { borderRadius: "10px" },
							fontFamily: "Figtree,sans-serif",
							marginBottom: '1rem',
						}}
						onChange={(e) => handleNameChange(e)}
						InputLabelProps={{
							shrink: true,
							sx: {
								fontFamily: "Figtree,sans-serif !important",
								fontSize: "16px !important",
								fontWeight: "bold",
								color: "#B2B4C5 !important",
								padding: "0 0.25rem",
								backgroundColor: "#fff",
							},
						}}
						placeholder="Please enter your name"
						value={data.userName || ""}
					/>
					<FormLabelTypography>Are you a seafarer?</FormLabelTypography>

					<RadioGroup row onChange={(e) => handleSeafarerChange(e?.target?.value)}>
						<Stack sx={{ width: '100%', margin: "1rem 0" }} gap={3} flexDirection="row">
							<RadioInputBoxes sx={{ width: '50%' }}>
								<StyledFormControl
									value={"ship"}
									checked={data.statusOfSeaFearer === "ship"}
									control={<StyledRadio />}
									label="Yes"
									sx={{ color: "#727484", fontFamily: "Figtree,sans-serif" }}
									componentsProps={{
										typography: {
											sx: {
												fontFamily: "Figtree,sans-serif",
											},
										},
									}}
								/>
							</RadioInputBoxes>
							<RadioInputBoxes sx={{ width: '50%' }}>
								<StyledFormControl
									value={"shore"}
									checked={data.statusOfSeaFearer === "shore"}
									control={<StyledRadio />}
									label="No"
									sx={{ color: "#727484", fontFamily: "Figtree,sans-serif" }}
									componentsProps={{
										typography: {
											sx: {
												fontFamily: "Figtree,sans-serif",
											},
										},
									}}
								/>
							</RadioInputBoxes>
						</Stack>
					</RadioGroup>

					<FormLabelTypography className="mb-2">
						What is your Role?
					</FormLabelTypography>

					{data.rolesObject && (
						<FormControlSingle focusedbordercolor={fieldHoverBorderColor} fullWidth sx={{ marginBlock: "14px" }}>
							<InputLabel
								shrink={true}
								sx={{
									fontFamily: "Figtree,sans-serif !important",
									fontSize: "16px",
									fontWeight: "bold",
									color: "#B2B4C5 !important",
								}}
							>
								Type <Mandatory mandatory fontSize="medium" top="0" />
							</InputLabel>
							<StyledSelect
								id="outlined-basic"
								variant="outlined"
								value={data?.role || ""}
								label="Select "
								onChange={(e) => handleRoleChange(e?.target?.value)}
								notched={true}
								sx={{
									...styles.textField,
									"& .MuiSvgIcon-root": { color: fieldHoverBorderColor, },
									fontFamily: "Figtree,sans-serif !important",
									fontSize: "16px !important",
									color: "#4F5B7D !important",
									'& .MuiInputBase-root': {
										fontFamily: "Figtree,sans-serif !important",
										fontSize: "16px !important",
										color: "#B2B4C5 !important",
										paddingRight: "9px !important",
										backgroundColor: "#fff",
									},
									"& .MuiOutlinedInput-root": {
										borderRadius: "10px",
										fontFamily: "Figtree,sans-serif !important",
										fontSize: '16px !important',
										color: '#4f5b7d !important',
									},
									"& .MuiSelect-select": {
										fontFamily: "Figtree,sans-serif",
										fontSize: "14px",
										color: "#4f5b7d !important",
										// placeholder: "Select your rank",
									},
									marginBottom: "10px",
									fontFamily: "Figtree,sans-serif",
								}}
								MenuProps={{
									sx: {
										zIndex: "999999999",
										height: "20rem",
									},
								}}
								// InputLabelProps={{
								// 	style: {
								// 		font: "Figtree,sans-serif",
								// 		fontSize: "16px",
								// 		fontWeight: "bold",
								// 		color: "#B2B4C5 !important",
								// 	},
								// }}
								// InputProps={{
								// 	style: {
								// 		font: "Figtree,sans-serif",
								// 		fontSize: "13px",
								// 		color: "#B2B4C5 !important",
								// 	},
								// 	placeholder: "Select your rank",
								// }}
								style={{ borderRadius: "10px" }}
							>
								<MenuItem value="" disabled>
									Select your role
								</MenuItem>
								{data.rolesObject[data.statusOfSeaFearer] &&
									data.rolesObject[data.statusOfSeaFearer].map(
										(name, index) => (
											<MenuItem
												key={index}
												value={name.info}
												sx={{ fontFamily: "Figtree,sans-serif" }}
											>
												{name.info}
											</MenuItem>
										)
									)}
							</StyledSelect>
						</FormControlSingle>
					)}
					{data.rankList && (
						<FormControlSingle focusedbordercolor={fieldHoverBorderColor} fullWidth className="my-2">
							<InputLabel
								shrink={true}
								sx={{
									fontFamily: "Figtree,sans-serif !important",
									fontSize: "16px",
									fontWeight: "bold",
									color: "#B2B4C5 !important",
								}}
							>
								Rank <Mandatory mandatory fontSize="medium" top="0" />
							</InputLabel>
							<StyledSelect
								id="outlined-basic"
								variant="outlined"
								label="Select"
								value={data?.rank || ""}
								onChange={(e) => handleRankChange(e)}
								notched={true}
								sx={{
									...styles.textField,
									"& .MuiSvgIcon-root": { color: fieldHoverBorderColor, },
									fontFamily: "Figtree,sans-serif !important",
									fontSize: "16px !important",
									color: "#4F5B7D !important",
									backgroundColor: !data.role ? 'rgb(244, 247, 251)' : 'inherit',
									borderRadius: "10px",
									'& .MuiInputBase-root': {
										fontFamily: "Figtree,sans-serif !important",
										fontSize: "16px !important",
										color: "#B2B4C5 !important",
										paddingRight: "9px !important",
										backgroundColor: "#fff",
									},
									"& .MuiOutlinedInput-root": {
										borderRadius: "10px",
										fontFamily: "Figtree,sans-serif !important",
										fontSize: '16px !important', color:
											'#4f5b7d !important',
									},
									"& .MuiSelect-select": {
										fontFamily: "Figtree,sans-serif",
										fontSize: "14px",
										color: "#4f5b7d !important",
									},
									marginBottom: "10px",
									fontFamily: "Figtree,sans-serif",
								}}
								MenuProps={{
									sx: {
										zIndex: "999999999",
										height: "20rem",
									},
								}}
								// InputLabelProps={{
								// 	style: {
								// 		font: "Figtree,sans-serif",
								// 		fontSize: "16px",
								// 		fontWeight: "bold",
								// 		color: "#B2B4C5 !important",
								// 	},
								// }}
								// InputProps={{
								// 	style: {
								// 		font: "Figtree,sans-serif",
								// 		fontSize: "13px",
								// 		color: "#B2B4C5 !important",
								// 	},
								// 	placeholder: "Select your rank",
								// }}
								disabled={!data.role}
							>
								<MenuItem value="" disabled>
									Select your rank
								</MenuItem>
								{data.rankList?.map((name, index) => (
									<MenuItem
										key={index}
										value={name.info}
										sx={{ fontFamily: "Figtree,sans-serif" }}
									>
										{name.info}
									</MenuItem>
								))}
							</StyledSelect>
						</FormControlSingle>
					)}
					<FormLabelTypography>Are you sailing?</FormLabelTypography>
					<RadioGroup
						row
						value={data.sailingStatus}
						onChange={(e) => setData((prevData) => ({
							...prevData,
							sailingStatus: e.target.value === "true",
						}))}
						defaultValue={false}
					>
						<Stack
							gap={3}
							sx={{ width: "100%", margin: "0.9rem 0" }}
							flexDirection="row"
						>
							<RadioInputBoxes sx={{ width: "50%" }}>
								<StyledFormControl
									value={true}
									control={<StyledRadio />}
									label="Yes"
									sx={{ color: "#727484", fontFamily: "Figtree,sans-serif" }}
									componentsProps={{
										typography: {
											sx: {
												fontFamily: "Figtree,sans-serif",
											},
										},
									}}
								/>
							</RadioInputBoxes>
							<RadioInputBoxes sx={{ width: "50%" }}>
								<StyledFormControl
									value={false}
									control={<StyledRadio />}
									label="No"
									sx={{ color: "#727484", fontFamily: "Figtree,sans-serif" }}
									componentsProps={{
										typography: {
											sx: {
												fontFamily: "Figtree,sans-serif",
											},
										},
									}}
								/>
							</RadioInputBoxes>
						</Stack>
					</RadioGroup>
					{data.sailingStatus && (
						<FormControl fullWidth className="mb-2">
							<StyledAutocomplete
								sx={{ mb: "10px", ...styles.textField, }}
								islabelvisible={true}
								open={data.isShipNameOpen}
								size="medium"
								id={"shipNameDropdown"}
								name={"shipName"}
								autoHighlight={true}
								loading={!data.dataLoaded}
								disableClearable
								onOpen={() => {
									setOpen(true);
								}}
								onClose={() => {
									setOpen(false);
								}}
								options={data.shipList || []}
								getOptionLabel={(option) => option.label || ""}
								isOptionEqualToValue={(option, value) =>
									option.label == value.label
								}
								inputValue={data.shipName}
								// defaultValue={data.shipName}
								onChange={(e, value) => handleShipSelect(value)}
								renderInput={(params) => (
									<StyledTextField
										{...params}
										name={"shipName"}
										value={data.shipName || ""}
										label={
											<>
												Vessel Name <Mandatory mandatory fontSize="medium" top="0" />
											</>
										}
										placeholder="Please enter your vessel name"
										InputLabelProps={{
											shrink: true,
											sx: {
												...styles.textField,
												fontFamily: "Figtree,sans-serif !important",
												fontSize: "16px !important",
												fontWeight: "bold",
												color: "#B2B4C5 !important",
												padding: "0 0.25rem",
												backgroundColor: "#fff",

											},
										}}
										onChange={handleShipNameSearch}
										onKeyDown={(e) => { e?.key === "Enter" && getShipDetails(data?.shipName, "shipName") }}
										error={data.shipNameError}
										InputProps={{
											...params.InputProps,
											endAdornment: (
												<Fragment>
													<InputAdornment
														position="start"
														sx={{ color: fieldHoverBorderColor, mr: 3 }}
													>
														{!data.dataLoaded ? (
															<CircularProgress
																size={20}
																thickness={4}
																sx={{ color: fieldHoverBorderColor }}
															/>
														) : (
															<Search onClick={() => getShipDetails(data?.shipName, "shipName")} sx={{ color: fieldHoverBorderColor, cursor: "pointer" }} />
														)}
													</InputAdornment>
													{params.InputProps.endAdornment}
												</Fragment>
											),
										}}
										sx={{
											...styles.textField,
											'& .MuiInputBase-root': {
												fontFamily: "Figtree,sans-serif !important",
												fontSize: "16px !important",
												color: "#B2B4C5 !important",
												paddingRight: "9px !important",
												backgroundColor: "#fff",
											},
											"& .MuiOutlinedInput-root": { borderRadius: "10px" },
											marginBottom: "10px",
											fontFamily: "Figtree,sans-serif",
										}}
									/>
								)}
							/>
						</FormControl>
					)}
					{data.sailingStatus && (
						<FormControl fullWidth className="mb-2">
							<StyledTextField
								id="outlined-basic"
								autoComplete="off"
								variant="outlined"
								label={
									<>
										Vessel IMO <Mandatory mandatory fontSize="medium" top="0" />
									</>
								}
								value={data.shipIMO || ''}
								InputLabelProps={{
									shrink: true,
									sx: {
										fontFamily: "Figtree,sans-serif !important",
										fontSize: "16px !important",
										fontWeight: "bold",
										color: "#B2B4C5 !important",
										padding: "0 0.25rem",
										backgroundColor: "#fff",
									},
								}}
								InputProps={{
									sx: {
										fontFamily: "Figtree,sans-serif",
										fontSize: "13px",
										color: "#B2B4C5",
									},
									placeholder: "Please enter your vessel IMO",
									endAdornment: (
										<Fragment>
											<InputAdornment
												position="start"
												sx={{ color: fieldHoverBorderColor, mr: 3 }}
											>
												{!data.imoDataLoaded ? (
													<CircularProgress
														size={20}
														thickness={4}
														sx={{ color: fieldHoverBorderColor }}
													/>
												) : (
													<Search onClick={() => getShipDetails(data?.shipIMO, "shipIMO")} sx={{ color: fieldHoverBorderColor, cursor: "pointer" }} />
												)}
											</InputAdornment>
										</Fragment>
									),
								}}
								onChange={handleShipNameSearch}
								onKeyDown={(e) => { e?.key === "Enter" && getShipDetails(data?.shipIMO, "shipIMO") }}
								name={"shipIMO"}
								sx={{
									...styles.textField,
									'& .MuiInputBase-root': {
										fontFamily: "Figtree,sans-serif !important",
										fontSize: "16px !important",
										color: "#B2B4C5 !important",
										paddingRight: "9px !important",
										backgroundColor: "#fff",
									},
									"& .MuiOutlinedInput-root": { borderRadius: "10px" },
									marginBottom: "10px",
									fontFamily: "Figtree,sans-serif",
								}}
							/>
						</FormControl>
					)}
				</Stack>
			</Scrollbars>
			<Stack flexDirection="row" justifyContent="space-around" sx={{ mt: 4, mx: " 1rem" }}>
				<FormControl sx={{ width: "50%", }}>
					<CustomButton
						onClick={props.closeModal}
						variant="outlined"
						sx={{
							color: "#727484",
							fontFamily: "Figtree,sans-serif",
							"&:hover": { border: "1px solid #D6D8E5" },
						}}
					>
						Cancel
					</CustomButton>
				</FormControl>
				<FormControl sx={{ width: "50%", ml: 1 }}>
					<CustomButtonWithoutBorder
						onClick={(e) => saveProfile(e)}
						variant="contained"
						sx={{
							backgroundColor: "#376afa",
							fontFamily: "Figtree,sans-serif",
							"&:hover": { backgroundColor: "#1d56f5" },
						}}
					>
						{isModalSaving ? <CircularProgress size={'1rem'} sx={{ ml: 1 }} color="secondary" />
							:
							"Save"
						}
					</CustomButtonWithoutBorder>
				</FormControl>
			</Stack>
		</>
	);
};

export default EditRoleDetails;
